<template>
  <section id="app-scan-qrcode-usb">
    <div class="d-flex">
      <img
        :src="AppImages.qrMan"
        alt="qr_logo"
        class="ma-auto mt-3"
        width="190"
        height="230"
      >
    </div>
    <h2 class="text-center mt-3">
      Scannez votre code barre
    </h2>
    <bottom-action
      btn-del
      :btn-del-disabled="action === ActionEnum.credit"
      btn-cancel
      :btn-cancel-disabled="(action === ActionEnum.credit && total > 0)"
      :btn-valid="action === ActionEnum.credit"
      :btn-valid-disabled="(action === ActionEnum.credit && total === 0)"
      :use-listener="false"
      @del="$emit('del')"
      @cancel="$emit('cancel')"
      @valid="$emit('valid')"
    />
  </section>
</template>

<script>
import { ActionEnum, IconEnum, SCAN_TYPE } from '@/modules/Enums'
import { AppImages } from '@/modules/Images'
import { $alert } from '@/modules/Utils'

export default {
  name: 'QrcodeUsbScan',

  props: {
    action: { type: Number, default: null },
    cancellable: { type: Boolean, default: true },
    deletable: { type: Boolean, default: true },
    locked: { type: Boolean, default: false },
    creditOnly: { type: Boolean, default: false },
    useListener: { type: Boolean, default: true },
    total: { type: Number, default: 0 }
  },

  data () {
    return {
      ActionEnum,
      IconEnum,
      AppImages,
      barcode: '',
      barcodeTimeout: null,
      barcodeIsReading: false,
      useDesktopListener: false
    }
  },

  watch: {
    useListener (newVal) {
      if (this.useDesktopListener) {
        if (newVal === true) {
          window.addEventListener('keypress', this.receiveBarcode, false)
        } else {
          window.removeEventListener('keypress', this.receiveBarcode, false)
        }
      }
    }
  },

  mounted () {
    // Ecoute clavier
    if (this.useListener) {
      this.useDesktopListener = true
      window.addEventListener('keypress', this.receiveBarcode, false)
    }
  },

  beforeDestroy () {
    // Arrêt du nfc
    if (this.useDesktopListener) {
      window.removeEventListener('keypress', this.receiveBarcode, false)
    }
  },

  methods: {
    receiveBarcode (e) {
      clearTimeout(this.barcodeTimeout)

      if (e.keyCode === 13) { // => 'Enter'
        this.$store.commit('loader', false)
        this.barcodeIsReading = false
        let uid = this.barcode
        this.barcode = ''

        // Contrôle du numéro reçu
        if (uid !== '') {
          // ===> START SCAN
          this.$emit('scan', uid, SCAN_TYPE.QR_CODE)
        }
      } else {
        // Ajout touche à la valeur du nfc
        this.barcode += String.fromCharCode(e.keyCode)
        // Si pas déjà fait, démarrage loader
        if (!this.barcodeIsReading) {
          this.barcodeIsReading = true
          $alert(false)
          this.$store.commit('loader', this.$i18n.t('loader.scan_support'))
        }
        // Reset en cas d'erreur de saisie (aucun autre caractère immédiat)
        this.barcodeTimeout = setTimeout(() => {
          this.$store.commit('loader', false)
          this.barcodeIsReading = false
          this.barcode = ''
        }, 200)
      }
    }
  }
}
</script>
